<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-8">
      <div class="d-flex w-100 justify-content-center">
        <a href="/style-library" class="card link-card"
          ><div class="fs-30 fw-600 mb-4">STYLE LIBRARY</div>
          <i class="bi bi-collection"></i
        ></a>

        <a href="/smart-assistant-feed" class="card link-card"
          ><div class="fs-30 fw-600 mb-4">SMART ASSISTANT FEED</div>
          <img
            src="/assets/icon-ai-assistant.svg"
            class="ai-icon"
            alt="AI Assistant"
        /></a>
      </div>
    </div>
  </div>
</div>
